export default __webpack_public_path__ + "resources/icons/d441-23d2.webp";